WiseMetering.Views.ActivateSite = WiseMetering.Views.Modal.Custom.extend({
    template: 'templates/sites/activate_site',
    title: () => i18next.t('modal.title.sites.activate'),
    buttons: ['yes', 'cancel'],
    className: 'mbx-info',

    yes: function() {
        this.model.activate().done(function() {
            this.collection.remove(this.model);
            this.close();
        }.bind(this));
    }
});
